import {Dialog, Button, Loading} from '@startlibs/components'
import { getFetcher } from '@startlibs/utils'
import React, { useEffect, useState } from 'react'
import _ from 'lodash/fp'
import styled from 'styled-components';
import { CardHeader } from '../errors/ProviderError';
import { StudyCard } from './StudyCard';
import { params } from '../../../../webpack/dataNameToClassSVGOPlugin';


const ErrorCard = styled.div`
  padding: 2.5rem;
  background: white;
  border-radius: 8px;
  border: 1px solid rgba(0, 0, 0, 0.15);
  max-width: 40rem;
  margin: 0 auto;
  p {
    font-size: 14px;
  }
`


const LoadingDiv = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
  justify-content: center;
  align-items: center;
  flex-grow: 1;
`


export const buildName = (nameObject) => {
  const nameArray = [
    nameObject?.lastName,
    nameObject?.firstName,
    nameObject?.middleName,
    nameObject?.prefix,
    nameObject?.suffix,
  ]
  const nameString = nameArray.join("^")
  return nameString
}

const splitName = (name) => {
  const nameArray = name.split("^")
  const nameObject = {
    lastName: nameArray[0],
    firstName: nameArray[1],
    middleName: nameArray[2],
    prefix: nameArray[3],
    suffix: nameArray[4],
  }
  return nameObject
}


export const HasArchivedStudiesDialog = ({study, closeDialog, viewer, setParams}) => {
  
  const [isLoading, setIsLoading] = useState(true)
  const [loadError, setLoadError] = useState(false)
  const [patientData, setPatientData] = useState({})

  const studyUid = study.study.iuid;

  useEffect(() => {
  
    // getting the stuy info direct from databse (may have been updated)
    const getDicomTagsUrl = `/getUpdateStudyInfo.php?study_iuid=${studyUid}`
    getFetcher(getDicomTagsUrl)
      .then((response) => {
        const nameObject = splitName(response.patientName)
        const newPatientData = {
          patientID: response.patientID,
          firstName: nameObject.firstName,
          middleName: nameObject.middleName,
          lastName: nameObject.lastName,
          patientName: response.patientName,
          patientSex: response.patientSex,
          patientDOB: response.patientDOB,
          institutionName: response.institutionName,
          study_desc: response.study_desc,
          countStudies: response.countStudies,
          patientPK: response.patientPK
        }
        setPatientData(newPatientData)
        setIsLoading(false)  
      })
      .catch((error) => {
        setLoadError(true)
        setIsLoading(false)
      });

  },[])

  
  return <Dialog
      // title="Patient has archived studies"
      title="Related studies are archived"
      closeDialog={closeDialog}
      footer={ () => {
        return <>
          <Button onClick={() => {
            // setParams(_.set('search', study.patient.patientID), true)  
            setParams(_.set('patientId', study.patient.patientID), true)  
            closeDialog();
          }}>Related study list</Button>
          <Button highlight 
            onClick={() => { 
              window.open(viewer, "_blank")
              closeDialog()
            }}
          >
            View this study
          </Button>
        </>}
      }
    >
      {isLoading 
        ? <LoadingDiv css="height:200px;">
            <Loading size={30} borderWidth={5}/>
          </LoadingDiv> 
        : loadError 
          ? <ErrorCard>
              <CardHeader>
                <h1>Something went wrong</h1>
              </CardHeader>
              <p><b>Please reload the page and try again.</b></p>
              <p>If the error persists please contact <a href="mailto:support@purview.net"
                                                        target="_blank">support@purview.net</a> or <span
                className="nowrap">call <b>+1 800-501-1537</b>.</span></p>
            </ErrorCard>
          : <>
              {/* <CurrentPatientStudyCard study={study} patientName={patientData.patientName} patientID={patientData.patientID} patientDOB={patientData.patientDOB}/> */}
              <StudyCard study={study} showRefPhysican/>
              {/* <p>Archived studies can not be loaded into viewer. You can list all studies related to this patient and unarchive them before launching the viewer.</p> */}
              <p>These studies must be unarchived before loading into the viewer. Click "Related study list" to unarchive prior studies or click "View this study" to open this study only.</p>
            </>  
      }
    </Dialog>
}
